import { configureStore } from '@reduxjs/toolkit';
import showAllSubtasksReducer from './redux/reducers/ShowSubTasks/subTaskReducer';
import showAddTaskInput from './redux/reducers/ShowAddTaskInput/showAddTaskInput';
import showEditModalReducer from './redux/reducers/ShowEditModal/editModalReducer';
import showProjectContextMenuReducer from './redux/reducers/ShowProjectContextMenu/ShowProjectContextMenuReducer';
import zoomLevelReducer from './redux/reducers/ZoomLevelReducer/zoomLevelReducer';
import userDetailsReducer from './redux/reducers/UserDetailsReducer/userDetailsReducer';
import { getFilterReducer } from './redux/reducers/FilterReducer/filterReducer';
import showUnsortedPanelReducer from './redux/reducers/ShowUnsortedPanel/showUnsortedPanelReducer';
import importReducer from './redux/reducers/TodoManipulation/importReducer';
import isDraggingReducer from './redux/reducers/IsDraggingReducer/isDraggingReducer';
import aiTasksToFirebaseReducer from "../src/redux/reducers/TodoManipulation/aiTasksToFirebaseReducer";
import SlideoutDataReducer from './redux/reducers/SlideoutDataReducer/SlideoutDataReducer';
import setNotificationSettingsReducer from './redux/reducers/SettingsReducer/setNotificationSettingsReducer';
import setUserSettingsReducer from './redux/reducers/SettingsReducer/setUserSettingsReducer';
import combinedReducer from './redux/reducers/CombinedReducer/combinedReducer';
import licenseReducer from './redux/reducers/CombinedReducer/licenseReducer';
import dateTimeReducer from "./redux/reducers/DateTimeReducer/dateTimeReducer"
import searchReducer from './redux/reducers/SearchResultReducer/searchResultReducer';
import aiTasksReducer from './redux/reducers/AiTaskReducer/aiTasksReducer';
import analyticsReducer from './redux/reducers/AnalyticsReducer/analyticsReducer';
import calendarEventsReducer from './redux/reducers/CalendarReducer/getCalendarReducer';
import showCalendarTasksPanelReducer from "./redux/reducers/ShowCalendarTasksPanel/showCalendarTasksPanelReducer";
import calendarMaxViewReducer from "./redux/reducers/CalendarMaxView/calendarMaxViewReducer";
import setCalendarUserSettingsReducer from './redux/reducers/SettingsReducer/setCalendarUserSettingsReducer';
import { deleteEventModalReducer } from './redux/reducers/DeleteEventModalReducer/deleteEventModalReducer';
import calendarPageReducer from './redux/reducers/ShowCalendarPage/calendarPageReducer';
import calendarColorsReducer from './redux/reducers/CalendarColorReducer/calendarColorReducer';
import sectionFilterReducer from './redux/reducers/SectionFilterReducer/sectionFilterReducer';
import disconnectReducer from './redux/reducers/CalendarReducer/disconnectReducer';
import calendarSyncTriggerReducer from './redux/reducers/CalendarReducer/calendarSyncTriggerReducer';
import taskToggleStateReducer from './redux/reducers/TaskToggleState/taskToggleStateReducer';


const store = configureStore({
    reducer: {
        showAllSubtasks: showAllSubtasksReducer,
        showAddTaskInput: showAddTaskInput,
        showEditModal: showEditModalReducer,
        showProjectContextMenu: showProjectContextMenuReducer,
        zoomLevel: zoomLevelReducer,
        userDetails: userDetailsReducer,
        taskList: combinedReducer,
        showUnsortedPanel: showUnsortedPanelReducer,
        showCalendarTasksPanel: showCalendarTasksPanelReducer,
        import: importReducer,
        isDragging: isDraggingReducer,
        aiTasksToFirebaseReducer: aiTasksToFirebaseReducer,
        slideoutData: SlideoutDataReducer,
        toDoFilterState: getFilterReducer('Todo'),
        overviewFilterState: getFilterReducer('Overview'),
        dueDateFilterState: getFilterReducer('Due-dates'),
        notificationSettings: setNotificationSettingsReducer,
        userSettings: setUserSettingsReducer,
        license: licenseReducer,
        selectedDate: dateTimeReducer,
        searchResult: searchReducer,
        addAiTasks: aiTasksReducer,
        sendEvent: analyticsReducer,
        calendarEvents: calendarEventsReducer,
        calendarMaxView: calendarMaxViewReducer,
        userCalendarSettings: setCalendarUserSettingsReducer,
        deleteEventModal: deleteEventModalReducer,
        showCalendarPage: calendarPageReducer,
        calendarColors: calendarColorsReducer,
        sectionFilters: sectionFilterReducer,
        disconnect: disconnectReducer,
        calendarSyncTrigger: calendarSyncTriggerReducer,
        taskToggleState: taskToggleStateReducer
    },
},
);

export default store;
